
// src/reducers/socket-reducer.js

import {
  SOCKET_CONNECT,
  SOCKET_RECONNECT,
  SOCKET_RECONNECTING,
  SOCKET_RECEIVE,
  SOCKET_DISCONNECT,
} from '../actions/socket'

import { deleteArray } from '../helpers/store'

const initialState = {
  status: undefined,
  items: {},
}

export default function socketReducer(state = initialState, action = {}) {
  switch(action.type) {
  case SOCKET_CONNECT:
    return Object.assign({}, state, {
      status: 'connected',
      items: {}
    })

  case SOCKET_RECONNECT:
    return Object.assign({}, state, {
      status: 'connected',
      items: {}
    })

  case SOCKET_RECONNECTING:
    return Object.assign({}, state, {
      status: 'reconnecting',
      items: {}
    })

  case SOCKET_DISCONNECT:
    return Object.assign({}, state, {
      status: undefined,
      items: {}
    })

  case SOCKET_RECEIVE:
    const items = state.items[action.message_type]
    return Object.assign({}, state, {
      items: Object.assign({}, state.items, {
        [action.message_type]: items ? items.concat(action.params) : [action.params]
      })
    })

  default:
    return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/socket-reducer.js